import React, { useEffect } from 'react';
import useORSMCore from '../../Hooks/useORSMCore';
import ORSMSlugForm from '../SlugForm/ORSMSlugForm';
import { useForm } from 'react-hook-form';
import styles from './ORSMDomainChange.module.scss';
import { Theme } from '../../../../Enums/Theme.enum';
import Button from '../../../../Components/Button/Button';
import Text from '../../../../Components/Base/Text/Text';
import useLoading from '../../../Base/Hooks/useLoading';
import apiClient from '../../../../Services/ApiClient';
import useApiClient from '../../../Base/Hooks/useApiClient';
import { useAppContext } from '../../../../Services/AppContext';

interface Props {
	rootWorkplaceId: string;
	onChange: () => void;
}

const ORSMDomainChange: React.FC<Props> = ({ rootWorkplaceId, onChange }) => {
	const formMethods = useForm();
	const { displayError } = useApiClient();
	const { isLoading, setIsLoading, RenderLoading } = useLoading(false);
	const { isProduction } = useAppContext();

	const {
		isSlugAvailable,
		setIsSlugAvailable,
		checkSlugAvailability,
		isLoadingVerification,
	} = useORSMCore({
		rootWorkplaceId,
	});

	const slug = formMethods.watch('slug');

	let domain = `https://${slug}.meddi.com`;

	if (!isProduction) {
		domain = `https://${slug}.meddi-devcal.cz`;
	}

	useEffect(() => {
		setIsSlugAvailable(false);
	}, [slug]);

	const handleChange = async () => {
		setIsLoading(true);
		try {
			const response = await apiClient.post('/partner-calendar/slug-create', {
				workplaceId: rootWorkplaceId,
				slug,
			});

			if (response.status === 200) {
				onChange();
			}
		} catch (e) {
			displayError(e);
		}
		setIsLoading(false);
	};

	if (isLoading) {
		return <RenderLoading />;
	}

	return (
		<div className={styles.wrapper}>
			<ORSMSlugForm
				formMethods={formMethods}
				onSlugAvailabilityCheck={() => checkSlugAvailability(slug)}
				isLoadingVerification={isLoadingVerification}
			/>
			{isSlugAvailable && (
				<>
					<div className={styles.available}>
						<img
							src='/dist/icons/subscription/circle-check-sharp-solid-full.svg'
							alt='Green check'
						/>
						<Text
							tx='component.ORSMActivation.domainIsAvailable'
							txParams={{ domain }}
						/>
					</div>
					<Text
						tx='component.ORSMDomainChange.warningMessage'
						className={styles.warning}
					/>
					<Button
						title='component.ORSMDomainChange.changeDomain'
						theme={Theme.GREEN}
						className={styles.button}
						onClick={handleChange}
					/>
				</>
			)}
		</div>
	);
};

export default ORSMDomainChange;
